var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-book-user-reviews-count label label-sm label-round"},[_vm._v("\n  "+_vm._s(_vm.userReviewsCount)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }